<form [formGroup]="bankaFormGroup">
  <kodit-dropdown
    [options]="items"
    formCtrlId="naziv"
    (optionChanged)="handleOnItemChange($event)"
  ></kodit-dropdown>
</form>
